module.exports = __webpack_public_path__ + "img/avator_small.a875f2cb.png";